import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Table} from 'primeng/table';
import {Funcionalidad} from '../../_models/funcionalidad';
import {NavService} from '../../_services/_nav.service';
import {Router} from '@angular/router';
import {AutenticacionService} from '../../_services/autenticacion.service';
import {TopeCanalService} from '../../_services/tope-canal.service';
import {TopeCanal} from '../../_models/tope-canal';
import {Subject, takeUntil} from 'rxjs';

@Component({
  selector: 'app-tope-inversion',
  templateUrl: './tope-inversion.component.html',
  styleUrl: './tope-inversion.component.css'
})
export class TopeInversionComponent implements OnInit, OnDestroy {

  // Variables para renderizado
  cargandoTopes: boolean = true;

  // Variables para listado
  busqueda: string = '';
  columns: any[];
  @ViewChild('dt', { static: true }) table: Table;
  listadoTopesInversion: TopeCanal[] = [];
  private destroy$ = new Subject<void>();

  // Variables para control de acciones
  menu: Funcionalidad = new Funcionalidad();

  constructor(private toperCanalService: TopeCanalService,
              private navServicio: NavService,
              private router: Router,
              private autServicio: AutenticacionService) {
  }

  ngOnInit() {
    this.cargarColumnas();
    this.toperCanalService.listado().pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response) => {
          this.listadoTopesInversion = response;
          this.cargarOpcionesMenu();
          this.cargandoTopes = false;
        },
        error: () =>  {
          this.listadoTopesInversion = [];
          this.cargandoTopes = false;
        }
      });
  }

  cargarOpcionesMenu() {
    const mn = this.autServicio.obtenerFuncionalidades().find( x => x.ruta === 'apl/tope-inversion' );
    if ( mn ) this.menu = mn;
  }

  cargarColumnas() {
    this.columns = [
      { field: 'canal', header: '*' + this.navServicio.buscarMensaje( 'TOPESINVERSION.LBL_CANAL' ), sort: false },
      { field: 'montoMinimo', header: '*' + this.navServicio.buscarMensaje( 'TOPESINVERSION.LBL_MONTOMINIMO' ), sort: false },
      { field: 'montoMaximo', header: '*' + this.navServicio.buscarMensaje( 'TOPESINVERSION.LBL_MONTOMAXIMO' ), sort: false },
      { field: 'plazoMinimo', header: '*' + this.navServicio.buscarMensaje( 'TOPESINVERSION.LBL_PLAZOMINIMO' ), sort: false },
      { field: 'plazoMaximo', header: '*' + this.navServicio.buscarMensaje( 'TOPESINVERSION.LBL_PLAZOMAXIMO' ), sort: false },
      { field: 'indicadorHabilitado', header: this.navServicio.buscarMensaje( 'LBL_HABILITADO' ), sort: false },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];
  }

  agregar() {
    this.router.navigate( [ 'apl/tope-inversion/agregar' ] );
  }

  editar(item: TopeCanal) {
    this.router.navigate( [ 'apl/tope-inversion/actualizar/', item.idTopeCanal ] );
  }

  detalle(item: TopeCanal) {
    this.router.navigate( [ 'apl/tope-inversion/detalle/', item.idTopeCanal ] );
  }

  setSearch() {
    this.navServicio.setSearch( 'tope-inversion.component', this.busqueda );
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
